import { Component } from '@angular/core';

@Component({
    selector: 'app-planning',
    templateUrl: './planning.component.html',
    styleUrls: ['./planning.component.sass'],
    standalone: false
})
export class PlanningComponent {

}
